import { Paper, Skeleton } from '@mui/material'

import { Subheader3 } from '@collaborate-health/uikit'

const FormsListItemSkeleton: React.FC = () => {
  return (
    <Paper
      variant='outlined'
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 1, padding: 1, height: 68 }}
    >
      <Skeleton variant='rounded' width={60} height={60} sx={{ marginLeft: -0.5 }} />

      <Subheader3 flex={1} noWrap>
        <Skeleton width='80%' />
      </Subheader3>
    </Paper>
  )
}

export default FormsListItemSkeleton

